import { getUserAgent, initEnv } from '@tencent/pmd-tools/lib/env';
import { loader } from '@tencent/pmd-tools/lib/little-loader';
import { REPORT_MATCH_ROOM_DATA_EVENT_ID, reportEvent } from '@tencent/pmd-vue/lib/wzry-game-room/report-helper';


export const isInAcceleratorApp = () => {
  const useragent = getUserAgent();
  const ua = useragent.toLowerCase();
  return ua.indexOf('mnaversion') > -1;
};

const setupWebViewJavascriptBridge = (callback) => {
  try {
    if (window && window.WebViewJavascriptBridge) {
      // eslint-disable-next-line no-undef
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    const WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  } catch (e) {}
};


// 通过客户端路由跳转
export const launchGame = function (schemeUrl, battleId, isReportMatchRoomData) {
  const env = initEnv();
  if (env.isIos) {
    setupWebViewJavascriptBridge((bridge) => {
      const url = `mna://web/webOut?url=${encodeURIComponent(schemeUrl)}`;
      if (isReportMatchRoomData) {
        reportEvent({
          eventId: REPORT_MATCH_ROOM_DATA_EVENT_ID.ENVIRO_READY_SUC,
          battleId,
        });
        reportEvent({
          eventId: REPORT_MATCH_ROOM_DATA_EVENT_ID.ENTER_CLIENT_SUC,
          battleId,
        });
      }
      bridge.callHandler('router', url, (ret) => {
        console.info('clientRouter callback: ', ret);
      });
    });
  } else {
    loader('https://dldir1.qq.com/INO/js/jsbridge.min.js', () => {
      if (isReportMatchRoomData) {
        reportEvent({
          eventId: REPORT_MATCH_ROOM_DATA_EVENT_ID.ENVIRO_READY_SUC,
          battleId,
        });
        reportEvent({
          eventId: REPORT_MATCH_ROOM_DATA_EVENT_ID.ENTER_CLIENT_SUC,
          battleId,
        });
      }
      const url = `mna://web?redirect=${encodeURIComponent(schemeUrl)}`;
      window.location.href = url;
    });
  }
};


// 客户端分享微信qq  data : {title:"分享标题",desc:"分享描述",url:"https://blog.bihe0832.com/",imgUrl:"https://blog.bihe0832.com/public/img/head.jpg"}
export const clientShare = function (data, callback) {
  data.url = encodeURIComponent(data.url);
  data.imgUrl = encodeURIComponent(data.imgUrl);
  data.useSpecial = 0;
  const env = initEnv();
  if (env.isIos) {
    data.title = encodeURIComponent(data.title);
    data.desc = encodeURIComponent(data.desc);
    setupWebViewJavascriptBridge((bridge) => {
      const iosUrl = `mna://MainPart/openShareView?title=${data.title}&desc=${data.desc}&url=${data.url}&imgUrl=${data.imgUrl}`;
      bridge.callHandler('router', iosUrl, (res) => {
        callback && callback(res);
      });
    });
  } else {
    loader('https://dldir1.qq.com/INO/js/jsbridge.min.js', () => {
      // eslint-disable-next-line no-undef
      call('shareMsg', data, (res) => {
        callback && callback(res);
      });
    });
  }
};

export const closePage = () => {
  const env = initEnv();
  if (env.isIos) {
    setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler('closePage', {}, () => { });
    });
  } else {
    // eslint-disable-next-line no-undef
    call('closePage', {}, () => { });
  }
};
